<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-16 md:py-12 py-8 landing">
    <div class="container mx-auto">
      <div
        class="lg:w-1/2 md:w-2/3 w-full mx-auto text-center lg:mb-16 md:mb-12 mb-8"
      >
        <h2 class="font-semibold fsize30 sm-fsize20 clr-black">
          Corporate Well-being Hub
        </h2>
        <p class="fsize16 sm-fsize14 mt-2">
          Discover the latest insights and innovations driving future-ready
          workplaces towards success.
        </p>
      </div>

      <swiper :options="swiperOption" class="mySwiper">
        <swiper-slide
          class="rounded-xl cust-shadow-FAQ mb-2"
          v-for="(item, index) in ffc_hub.result"
          :key="index"
        >
          <div class="cursor-pointer" @click="handleClick(item)">
            <div class="w-full">
              <!-- src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg" -->
              <img
                :src="`${$imageURL}/${item.image}`"
                class="lg:h-44 h-40 w-full lg:pb-4 md:pb-4 pb-2 sm-w-full custimghover rounded-t-xl object-cover"
                alt="img"
              />
            </div>

            <div class="p-4 text-center h-40">
              <div
                class="flex justify-center items-center lg:mb-4 md:mb-3 mb-2"
              >
                <h3 class="fsize20 sm-fsize16 font-semibold text-primary">
                  <!-- FFC Podcast -->
                  {{ item.heading }}
                </h3>
                <feather-icon
                  icon="ArrowRightIcon"
                  class="text-primary"
                  svgClasses="w-5 h-5 ml-1"
                ></feather-icon>
              </div>

              <p class="fsize16 sm-fsize14 ellipsis-3">
                <!-- Duis aute irure dolor in it esse cillum fugiat nulla pari erunt
              mollit anim id est laborum. -->
                {{ item.description }}
              </p>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <!-- <div class="rounded-xl cust-shadow-FAQ" @click="handleClick('future-trends')" >
          <div class="w-full">
            <img
              class="lg:h-44 h-40 w-full lg:pb-4 md:pb-4 pb-2 sm-w-full custimghover rounded-t-xl"
              src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
              alt="img"
            />
          </div>

          <div class="p-4 text-center">
            <div class="flex justify-center items-center lg:mb-4 md:mb-3 mb-2">
              <h3 class="fsize20 sm-fsize16 font-semibold text-primary">
                FFC Podcast
              </h3>
              <feather-icon
                icon="ArrowRightIcon"
                class="text-primary"
                svgClasses="w-5 h-5 ml-1"
              ></feather-icon>
            </div>

            <p class="fsize16 sm-fsize14">
              Duis aute irure dolor in it esse cillum fugiat nulla pari erunt
              mollit anim id est laborum.
            </p>
          </div>
        </div> -->

        <!-- <div class="rounded-xl cust-shadow-FAQ">
          <div class="w-full">
            <img
              class="lg:h-44 h-40 w-full lg:pb-4 md:pb-4 pb-2 sm-w-full custimghover rounded-t-xl"
              src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
              alt="img"
            />
          </div>

          <div class="p-4 text-center">
            <div class="flex justify-center items-center lg:mb-4 md:mb-3 mb-2">
              <h3 class="fsize20 sm-fsize16 font-semibold text-primary">
                FFC Podcasth
              </h3>
              <feather-icon
                icon="ArrowRightIcon"
                class="text-primary"
                svgClasses="w-5 h-5 ml-1"
              ></feather-icon>
            </div>

            <p class="fsize16 sm-fsize14">
              Duis aute irure dolor in it esse cillum fugiat nulla pari erunt
              mollit anim id est laborum.
            </p>
          </div>
        </div> -->

        <!-- <div class="rounded-xl cust-shadow-FAQ">
          <div class="w-full">
            <img
              class="lg:h-44 h-40 w-full lg:pb-4 md:pb-4 pb-2 sm-w-full custimghover rounded-t-xl"
              src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
              alt="img"
            />
          </div>

          <div class="p-4 text-center">
            <div class="flex justify-center items-center lg:mb-4 md:mb-3 mb-2">
              <h3 class="fsize20 sm-fsize16 font-semibold text-primary">
                FFC Podcast
              </h3>
              <feather-icon
                icon="ArrowRightIcon"
                class="text-primary"
                svgClasses="w-5 h-5 ml-1"
              ></feather-icon>
            </div>

            <p class="fsize16 sm-fsize14">
              Duis aute irure dolor in it esse cillum fugiat nulla pari erunt
              mollit anim id est laborum.
            </p>
          </div>
        </div> -->
      </swiper>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 30,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          820: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true,
      },

      openAddBannerSidebar: false,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    async dataLoad() {
      await this.$store.dispatch("ffc/get_hub");
    },
    handleClick(item) {
      if (item.heading === "Corporate Events") {
        this.$router.push({ name: "corporate-events" });
      } else if (item.heading === "Future Trends") {
        this.$router.push({ name: "futures" });
      } else if (item.heading === "Well-being Initiatives") {
        this.$router.push({ name: "wellbeing-initiatives" });
      } else if (item.heading === "FFC Podcast") {
        // this.$router.push({ name: "ffc-podcast" });
        this.$router.push({
          name: "channelpage",
          query: { cid: "668b747e277b9a0012b9f91f" },
        });
      } else {
        return null;
      }
    },
  },
  computed: {
    ...mapState("ffc", { ffc_hub: "ffc_hub" }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
<style>
.bg-41193d {
  background: #41193d;
}
.fsize30 {
  font-size: 30px;
}
.landing .swiper-button-next {
  border-radius: 100% !important;
  background-size: 57px !important;
  width: 36px !important;
  height: 27px !important;
  background-size: 57px 52px !important;

  background-repeat: no-repeat !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
.landing .swiper-button-prev {
  border-radius: 100% !important;
  background-size: 57px !important;
  width: 36px !important;
  height: 27px !important;
  background-size: 57px 52px !important;

  background-repeat: no-repeat !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  font-size: 18px !important;
}
</style>
